import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["buttonVariant"],
  _excluded2 = ["href"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { Link } from '@hub/link';
import { Button } from '@hub/button';
import useFeatureFlag from '../../hooks/use-feature-flag';
import { FeatureFlagName } from '../../feature-flags';
import { jsx as _jsx } from "react/jsx-runtime";
export let MagicLinkValue = /*#__PURE__*/function (MagicLinkValue) {
  MagicLinkValue[MagicLinkValue["stores"] = 0] = "stores";
  MagicLinkValue[MagicLinkValue["centres"] = 1] = "centres";
  return MagicLinkValue;
}({});
const MagicLinkContext = /*#__PURE__*/React.createContext([null, () => {}]);
export const MagicLinkProvider = _ref => {
  let {
    children
  } = _ref;
  const value = React.useState(null);
  return /*#__PURE__*/_jsx(MagicLinkContext.Provider, {
    value: value,
    children: children
  });
};
export const useMagicLink = () => {
  return React.useContext(MagicLinkContext);
};
const MagicLink = _ref2 => {
  let {
      buttonVariant
    } = _ref2,
    linkProps = _objectWithoutProperties(_ref2, _excluded);
  const [, setValue] = useMagicLink();
  const storeDirectoryEnabled = useFeatureFlag(FeatureFlagName.NEXT_PUBLIC_FEAT_FLAG_ENABLE_STORE_DIRECTORY);
  const handleClick = e => {
    var _linkProps$onClick;
    (_linkProps$onClick = linkProps.onClick) === null || _linkProps$onClick === void 0 || _linkProps$onClick.call(linkProps, e);
    e.preventDefault();
    if (linkProps.href === '/stores') {
      setValue(MagicLinkValue.stores);
    }
    if (linkProps.href === '/centres') {
      setValue(MagicLinkValue.centres);
    }
  };
  const {
    href
  } = linkProps;
  if (href === '/centres' || !storeDirectoryEnabled && href === '/stores') {
    return /*#__PURE__*/_jsx(Link, _objectSpread(_objectSpread({}, linkProps), {}, {
      as: _ref3 => {
        let {
            href: _href
          } = _ref3,
          props = _objectWithoutProperties(_ref3, _excluded2);
        return /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
          variant: buttonVariant
        }, props), {}, {
          "data-id": "magic-link_index_MagicLinkProvider_Button"
        }));
      },
      onClick: handleClick,
      "data-id": "magic-link_index_MagicLinkProvider_Link"
    }));
  }
  return /*#__PURE__*/_jsx(Link, _objectSpread(_objectSpread({}, linkProps), {}, {
    "data-id": "magic-link_index_MagicLinkProvider_Link"
  }));
};
export default MagicLink;